module.exports = __webpack_public_path__ + "img/arrow_left_outline_grey.2bddd272.png";